export default __webpack_public_path__ + "static/media/settings.465479ac.svg";